// extracted by mini-css-extract-plugin
export default {"card-info":"styles_card-info__9D0ju","head":"styles_head__Oo-WK","icon":"styles_icon__GTAzH"};